<template>
  <div class="Ranking">
    <div class="title row-center" style="justify-content: left;">
      <div class="block">
        <span class="demonstration">选择日期：</span>
        <el-date-picker v-model="date" :picker-options="pickerOptions" type="month" placeholder="选择日期">
        </el-date-picker>
      </div>
      <!-- <div class="block">
        <span class="demonstration">回路/类型：</span>
        <el-select v-model="value" placeholder="请选择">
          <el-option
            v-for="item in options"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          >
          </el-option>
        </el-select>
      </div> -->
      <!-- <div class="block" v-if="value=='回路'">
        <span class="demonstration">站点：</span>
        <el-select v-model="sitevalue" placeholder="请选择">
          <el-option
            v-for="item in site"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          >
          </el-option>
        </el-select>
      </div> -->
    </div>
    <div class="cont">
      <div class="left">
        <div class="panelone" v-loading="loading">
          <charts id="RankingCharts" :option="RankingOption(0)"></charts>
        </div>
        <div class="panelone"   v-loading="loading">
          <charts id="RankingCharts1" :option="RankingOption(1)"></charts>
        </div>
      </div>
      <div class="right report ">
        <div class="tt">
          <!-- -{{value}} -->
          用电排名-{{value}}

          <div class="tag">
            <span :class="index=='in'?'active':''" @click="index='in'">进线</span>
            <span :class="index=='out'?'active':''"  @click="index='out'">出线</span>
          </div>
        </div>
        <RankTable :tableData="tableData" :loading="loading"></RankTable>
      </div>
    </div>
  </div>
</template>

<script>
import charts from "../../../components/Energy/charts";
import RankTable from "./RankTable.vue"
import {
    powerRankings
} from "../../../api/power";
import {
  floatFormat
} from "../../../util/MathUtil";
import {
		perDay,
		perMonth,
		perYear,
		nextDay,
		monthStart,
		yearStart,
		monthEnd,
		yearEnd,
		nextMonth,
		nextYear,
		dateFormat,
		dayStart,
		dayEnd,
	} from "../../../util/DateUtil";
export default {
  components: {
    charts,RankTable
  },
  data() {
    return {
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() > Date.now();
        },
      },
      date: new Date(),
      sitevalue:"全部",
      site:[{
            value: "全部",
            label: "全部",
        },
          {
            value: "站点1",
            label: "站点1",
        },
        {
            value: "站点2",
            label: "站点2",
        },
      ],
      options: [
        {
          value: "回路",
          label: "回路",
        },
        {
          value: "类型",
          label: "类型",
        },
      ],
      value: "回路",
      // tableData:[],
      AllData:{},
      sortListD:[],
      preListD:[],
      index:"out",
      loading:true
    };
  },
  computed: {
    RankingOption() {
      return function(value) {
        let formatter = "{name|当月}\n{name|用电量占比}";
        let text = "当月\n用电量占比";
        let data = [];
        if (value == 1) {
          formatter = "{name|上月}\n{name|用电量占比}";
          text = "上月\n用电量占比";
          data = this.preListD
        } else {
          data = this.sortListD
        }
        return {
          color: ["#5B8FF9", "#5D7092", "#F6BD16", "#E8684A", "#5AD8A6"],
          tooltip: {
            trigger: "item",
            position: 'right',
            formatter: function(obj){
              return obj.marker+obj.name+"："+obj.value
            }
          },
          legend: {
            orient: "vertical", //垂直显示
            y: "bottom", //延Y轴居中
            x: "5%", //居右显示
            icon: "rect",
            itemWidth: 8,
            itemHeight: 8,
            // itemGap: 14,
            textStyle: {
              fontSize: "16rem",
              fontWeight: 800,
              width:20
            },
            formatter: function(name){
          　　　　return name.length>20?name.substr(0,20)+"...":name;
          　}
          },
           grid:{
                x: 80,
                y: 60,
                x2: 80,
                y2: 60,

            },
            
					graphic:{       //图形中间文字
						type:"text",
						left:"center",
						top:"28%",
						style:{
							text:text,
							textAlign:"center",
							fontSize:"18rem",
							lineHeight: 30,
							fontWeight: 800,
						}
					},
          series: [
            {
              // name: "访问来源",
              type: "pie",
              center:["50%","35%"],
              radius: ["30%", "45%"],
              // roseType: 'area',
              // labelLine: {
              //   show: true,
              // },
              // label: {
              //   show: true,
              //   position: "center",
              // },
              // label: {
              //   normal: {
              //     show: true,
              //     position: "center",
              //     formatter: formatter,
              //     rich: {
              //       name: {
              //         color: "#333333",
              //         fontSize: 15,
              //         lineHeight: 30,
              //         fontWeight: 800,
              //       },
              //     },
              //   },
              // },
              label: {
                  show:true,
                  formatter: "{time|{d}%}",
                  minMargin: 5,
                  edgeDistance: 10,
                  lineHeight: 25,
                  fontSize: 18,
                  fontWeight: 800,
                  rich: {
                    time: {
                      fontSize: 16,
                      color: "#0D94FF",
                    },
                  },
              },
              itemStyle: { // 此配置
                  normal: {
                      borderWidth: 1,
                      borderColor: '#ffffff',
                  },
                  // emphasis: {
                  //     borderWidth: 0,
                  //     shadowBlur: 1,
                  //     shadowOffsetX: 0,
                  //     shadowColor: 'rgba(0, 0, 0, 0.1)'
                  // }
              },
              labelLine: {
                  // length: 30,
                  // length2: 100,
                  show: true,
                  lineStyle:{
                      width:2
                  }
                  // color: "#00ffff",
              },
              data: data,
            },
          ],
        };
      };
    },
    tableData(){
      return this.AllData[this.index]
    },
    
  },
  watch:{
    date(n,o){
      this.getLooplist();
    },
    index(n,o){
      // this.getLooplist();
      this.preList();
      this.sortList();
    }
  },
  mounted(){
    this.getLooplist();
  },
  methods:{
    floatFormat,
    sortList(){
      if(JSON.stringify(this.AllData) != "{}"){
          let list = JSON.parse(JSON.stringify(this.AllData));
        this.sortListD = list[this.index].sort(function(a,b){
          return b.sum - a.sum
        }).filter((e)=>{e.name=e.loopName;e.value=e.sum.toFixed(2); return e}).slice(0,5)
      }else{
        this.sortListD = []
      }
      
    },
    preList(){
        if(JSON.stringify(this.AllData) != "{}"){
          let list = JSON.parse(JSON.stringify(this.AllData));
          this.preListD =list[this.index].sort(function(a,b){
            return b.lastMonthSum - a.lastMonthSum
          }).filter((e)=>{e.name=e.loopName;e.value=e.lastMonthSum.toFixed(2); return e}).slice(0,5)
        }else{
          this.preListD = []
        }
    },
    getLooplist(){
        this.loading = true
        powerRankings(dayStart(this.date)).then((res) => {
          this.AllData = res.data.data.list;
          this.preList();
          this.sortList();
          this.loading = false
      });
    },
  }
};
</script>

<style scoped lang="less">
.tag{
  float: right;
  span{
    border-radius: 20px;
    border: 1px solid #ddd;
    display: inline-block;
    width: 100px;
    text-align: center;
    height: 38px;
    line-height: 38px;
    overflow: hidden;
    font-weight: 500;
    color: #666;
    margin-left: 10px;
    cursor: pointer;
  }
  .active{
    background: #0d94ff ;
    color: #fff;
    border: 1px solid #0d94ff;
  }
}
.Ranking {
  height: 100%;
  font-size: 18rem;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
  .panelone {
    height: 49%;
    background: #ffffff;
    padding-bottom: 20rem;
    width: 100%;
  }
  img{
      
  }
  .tt {
    font-size: 18rem;
    font-weight: 700;
    color: #333;
    height: 44rem;
  }
  .cont {
    width: 100%;
    height: 80vh;
    display: flex;
    justify-content: space-between;
    align-items: center;
    .left {
      width: 17vw;
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      align-items: center;
      height: 100%;
    }
    .right {
      width: 66vw;
      height: 100%;
      background: #ffffff;
      padding: 24rem;
    }
  }
  .title {
    background: #ffffff;
    height: 8vh;
    padding-left: 70rem;
    width: 100%;
    .demonstration {
      margin-right: 10rem;
    }
    .block {
      margin-right: 80rem;
    }
  }
}
</style>
